import React, { useState, useEffect, useContext } from "react";

import {
  Paper,
  TableContainer,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Table,
  Stack,
} from "@mui/material";
import { isEmpty } from "lodash";
import { DataContext } from "../../../context/DataContext";
import { simpleMessage } from "../../../helpers/Helpers";
import { getToken } from "../../../api/Account";
import NoData from "../../../components/NoData";
import SearchField from "../../../components/ui/SearchField";
import ListFooter from "../../../components/ui/ListFooter";
import { getListTipoCambioAsync } from "../../../api/TipoCambio";
import moment from "moment/moment";
import { monoFont } from "../../../theme";

const TasaCambioList = () => {
  const [tasaCambioList, setTasaCambioList] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const withSearch = tasaCambioList.filter((val) => {
    if (searchTerm === "") {
      return val;
    } else if (moment(val.fecha).format("L").toString().includes(searchTerm)) {
      return val;
    }
    return false;
  });

  const { setIsLoading, setIsUnautorized } = useContext(DataContext);

  const token = getToken();

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const result = await getListTipoCambioAsync(token);
      if (!result.statusResponse) {
        setIsLoading(false);
        if (result.error === "Unauthorized") {
          setIsUnautorized(true);
          return;
        }
        simpleMessage(result.error, "error");
        return;
      }

      setIsLoading(false);
      // El endpoint devuelve { isSuccess, result }: antes se guardaba `data`
      // completo y el .filter() de mas abajo reventaba al no ser un arreglo.
      setTasaCambioList(result.data.result || []);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsperPage] = useState(10);
  const indexLast = currentPage * itemsperPage;
  const indexFirst = indexLast - itemsperPage;
  const currentItem = withSearch.slice(indexFirst, indexLast);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const onChangeSearch = (val) => {
    setCurrentPage(1);
    setSearchTerm(val.toUpperCase());
    paginate(1);
  };

  return (
    <div>
      <Paper sx={{ overflow: "hidden" }}>
        <Stack
          direction={{ xs: "column", sm: "row" }}
          justifyContent="space-between"
          alignItems={{ xs: "stretch", sm: "center" }}
          spacing={2}
          flexWrap="wrap"
          sx={{ padding: "18px 22px", borderBottom: "1px solid", borderColor: "divider" }}
        >
          <SearchField
            value={searchTerm}
            onChange={onChangeSearch}
            placeholder="Buscar por fecha…"
          />
        </Stack>

        {isEmpty(currentItem) ? (
          <NoData />
        ) : (
          <>
            <TableContainer sx={{ overflowX: "auto" }}>
              <Table sx={{ minWidth: 480 }}>
                <TableHead>
                  <TableRow>
                    <TableCell align="center">#</TableCell>
                    <TableCell align="center">Fecha</TableCell>
                    <TableCell align="right">1 US$ =</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {currentItem.map((row) => {
                    const { id, fecha, dolar } = row;
                    return (
                      <TableRow key={id} hover>
                        <TableCell align="center" sx={{ color: "text.disabled", fontWeight: 600 }}>
                          {id}
                        </TableCell>
                        <TableCell align="center" sx={{ color: "text.secondary" }}>
                          {moment(fecha).format("L")}
                        </TableCell>
                        <TableCell
                          align="right"
                          sx={{ fontFamily: monoFont, fontWeight: 700, color: "text.primary", whiteSpace: "nowrap" }}
                        >
                          {new Intl.NumberFormat("es-NI", {
                            style: "currency",
                            currency: "NIO",
                          }).format(dolar)}
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>

            <ListFooter
              data={withSearch}
              currentCount={currentItem.length}
              indexFirst={indexFirst}
              paginate={paginate}
              itemsperPage={itemsperPage}
              noun="registros"
            />
          </>
        )}
      </Paper>
    </div>
  );
};

export default TasaCambioList;
